import { RadioSwatchGroup_Field_default } from "./chunk-G7EBT36X.js";
import { RadioSwatchGroup_default } from "./chunk-TD2DTXNB.js";
import { RadioSwatchGroup_MoreButton_default } from "./chunk-Q6PBGZUV.js";

// src/components/RadioSwatchGroup/index.ts
var RadioSwatchGroupComponent = RadioSwatchGroup_default;
RadioSwatchGroupComponent.Field = RadioSwatchGroup_Field_default;
RadioSwatchGroupComponent.Field.displayName = "RadioSwatchGroup.Field";
RadioSwatchGroupComponent.MoreButton = RadioSwatchGroup_MoreButton_default;
RadioSwatchGroupComponent.MoreButton.displayName = "RadioSwatchGroup.MoreButton";
export { RadioSwatchGroupComponent };